import {createContext} from 'react';

const context = createContext<SetState<boolean>>(() => {
    throw new Error('Unitialized context');
});

context.displayName = 'Show Known Routes Snackbar Context';

export default context;
